import { remarketInfoAPI } from "@/views/RemarketContractorInfo/api";

export const getContractorInfo = async (contractor_id) => {
  try {
    const res = await remarketInfoAPI.getContractorInfo(contractor_id);
    return res;
  } catch (e) {}
};
export const updateContractorInfo = async (body) => {
  try {
    const res = await remarketInfoAPI.updateContractorInfo(body);
    return res;
  } catch (e) {}
};
export const getContractorPhotos = async (contractor_id) => {
  try {
    const res = await remarketInfoAPI.getContractorPhotos(contractor_id);
    return res?.data;
  } catch (e) {}
};
export const addContractorPhoto = async (body) => {
  try {
    const res = await remarketInfoAPI.addContractorPhoto(body);
    return res?.data;
  } catch (e) {}
};

export const deleteContractorPhoto = async (partner_project_photo_id) => {
  try {
    const res = await remarketInfoAPI.deleteContractorPhoto(partner_project_photo_id);
    return res;
  } catch (e) {}
};

export const getContractorReviews = async (contractor_id) => {
  try {
    const res = await remarketInfoAPI.getContractorReviews(contractor_id);
    return res?.data;
  } catch (e) {}
};
export const addContractorReview = async (body) => {
  try {
    const res = await remarketInfoAPI.addContractorReview(body);
    return res?.data;
  } catch (e) {}
};
export const deleteContractorReview = async (partner_review_id) => {
  try {
    const res = await remarketInfoAPI.deleteContractorReview(partner_review_id);
    return res;
  } catch (e) {}
};

export const photoColumns = [
  {
    name: "partner_project_photo_id",
    label: "ID",
    field: "partner_project_photo_id",
    align: "center",
  },
  {
    name: "photo_url_mini",
    label: "Фото",
    field: "photo_url_mini",
    align: "center",
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
  },
];
export const reviewsColumns = [
  {
    name: "partner_review_id",
    label: "ID",
    field: "partner_review_id",
    align: "center",
  },
  {
    name: "client_name",
    label: "Клиент",
    field: "client_name",
    align: "center",
  },
  {
    name: "review_text",
    label: "Отзыв",
    field: "review_text",
    align: "center",
  },
  {
    name: "review_score",
    label: "Оценка",
    field: "review_score",
    align: "center",
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
  },
];
